export const HOME = {
  primaryLink: "home-primary-link",
};

export const NAV = {
  logo: "nav-logo",
  servicesLink: "nav-services-link",
  aboutLink: "nav-about-link",
  trackLink: "nav-track-link",
  contactLink: "nav-contact-link",
  quoteBtn: "nav-quote-btn",
  trackingInput: "nav-tracking-input",
  trackingSubmit: "nav-tracking-submit",
  mobileToggle: "nav-mobile-toggle",
  social: (p) => `nav-social-${p}`,
};

export const HERO = {
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
  quoteFrom: "hero-quote-from",
  quoteTo: "hero-quote-to",
  quoteWeight: "hero-quote-weight",
  quoteService: "hero-quote-service",
  quoteSubmit: "hero-quote-submit",
};

export const SERVICES = {
  card: (slug) => `service-card-${slug}`,
  cta: (slug) => `service-cta-${slug}`,
};

export const SOCIAL_FEED = {
  card: (i) => `social-card-${i}`,
  platformFilter: (p) => `social-filter-${p}`,
};

export const QUOTE = {
  step: (n) => `quote-step-${n}`,
  next: "quote-next",
  back: "quote-back",
  submit: "quote-submit",
  field: (name) => `quote-field-${name}`,
};

export const FOOTER = {
  social: (p) => `footer-social-${p}`,
  newsletterInput: "footer-newsletter-input",
  newsletterSubmit: "footer-newsletter-submit",
};
